var SyncDescriptor = /** @class */ (function () {
    function SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation) {
        if (staticArguments === void 0) { staticArguments = []; }
        if (supportsDelayedInstantiation === void 0) { supportsDelayedInstantiation = false; }
        this.ctor = ctor;
        this.staticArguments = staticArguments;
        this.supportsDelayedInstantiation = supportsDelayedInstantiation;
    }
    return SyncDescriptor;
}());
export { SyncDescriptor };



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/instantiation/common/descriptors.js
// module id = 527
// module chunks = 58